<template>
    <div id="verified">
        
        <div class="card-other" >
            <h4>尊敬的用户,十分抱歉。本公司会与3个工作日内处理反馈。如有耽误使用请联系客服加急处理。</h4>
            <div class="main">
                <form >
                    <div class="line">
                        <label>反馈卡号：</label>
                        <div>
                            <input type="text" v-model="verifiedInfo.iccid" :disabled="disabledFlag"   placeholder="每个卡号只能提交一次，请认真填写">
                        </div>                    
                    </div>
                    <div class="line">
                        <label>联系手机号：</label>
                        <div>
                            <input type="text" v-model="verifiedInfo.phone" :disabled="disabledFlag"   placeholder="填写错误，则无法进行后续处理">
                        </div>                    
                    </div>
                    <div class="line">
                        <label>问题描述：</label>
                        <div>
                            <input type="text" v-model="verifiedInfo.remark" :disabled="disabledFlag" placeholder="详细的问题描述，可以为您更快得处理">
                        </div>                    
                    </div>
                    
                    
                    <div class="title" style="color:red">上传所有支付订单凭证 否则无法核实，将无法处理。每个卡号只能提交一次 请填写完整</div>                
                    <div class="many">                    
                        <div class="uploadOuter">                        
                            <input type="file" ref="file1" @change="showImg($event, 'existFrontImg', 'frontImgUrl')" :disabled="disabledFlag">   
                            <div v-if="!existFrontImg">凭证一</div>
                            <img v-else :src="frontImgUrl" alt="">  
                        </div>
                        <div class="uploadOuter">
                            <input type="file" ref="file2" @change="showImg($event, 'existBackImg', 'backImgUrl')" :disabled="disabledFlag">
                            <div v-if="!existBackImg">凭证二</div>
                            <img v-else :src="backImgUrl" alt="">  
                        </div>
                    </div>
                    <div class="many">                    
                       <div class="uploadOuter">
                            <input type="file" ref="file3" @change="showImg($event, 'existHandImg', 'handImgUrl')" :disabled="disabledFlag">
                            <div v-if="!existHandImg">凭证三</div>
                            <img v-else :src="handImgUrl" alt="">  
                        </div>
                         <div class="uploadOuter">
                            <input type="file" ref="file4" @change="showImg($event, 'existHandImgs', 'handImgUrl2')" :disabled="disabledFlag">
                            <div v-if="!existHandImgs">凭证四</div>
                            <img v-else :src="handImgUrl2" alt="">  
                        </div>
                        
                    </div>
                    <div class="btnOuter">
                        <mt-button type="primary" size="large" @click.prevent="sureVerifiedHandler" :disabled="disabledFlag">确定</mt-button>
                        <mt-button type="primary" size="large" @click.prevent="sureVerifiedHandler1" :disabled="disabledFlag">查询反馈记录</mt-button>
                    </div>    

                </form>
            </div>
        </div>
    </div>
</template>
<script>
import {wxRequest, verified} from '@/api/user'
import Clipboard from 'clipboard';
export default {
    data(){
        return {
            setPay:localStorage.getItem('iccid'),
            recordLoginText:localStorage.getItem('recordLoginText'),
            state: '',
            supplierTypeCode: '',
            verifiedInfo: {
                iccid: localStorage.getItem('recordLoginText'),
                nickname: '',
                phone: '',
                remark:'',
                cardCode: '',
                intoNo: localStorage.getItem('intoNo'),
            },
            disabledFlag: false,
            existFrontImg: false,
            existBackImg: false,
            existHandImg: false,
            existHandImgs:false,
            frontImgUrl: '',
            backImgUrl: '',
            handImgUrl: '',
            handImgUrl2: '',
            cuccAuth:''
        }
    },
    methods: {
        sureVerifiedHandler1(){
         this.$router.push({
            path: "/user/subSelect"
         })
        },
        onCopy(){
           window.alert('复制成功')
        },
        copy() {
        var clipboard = new Clipboard('.tag-read')
        clipboard.on('success', e => {
                  console.log('复制成功')
                  window.alert("复制成功");
                  clipboard.destroy()// 释放内存
             })
        clipboard.on('error', e => {
               console.log('不支持复制,该浏览器不支持自动复制')
               alert("复制失败")
               clipboard.destroy()// 释放内存
             })
         },
        getVerifiedInfoHandler(){            
            var data = {
                iccid: localStorage.getItem('iccid')
            }
            wxRequest("wxAuth/list", data, "post").then(res => {  
                if(res.data.code == 200 && res.data.data){
                    for(var key in this.verifiedInfo){
                        this.verifiedInfo[key] = res.data.data[key];
                        this.existFrontImg = true;
                        this.existBackImg = true;
                        this.existHandImg = true;
                        this.frontImgUrl = process.env.VUE_APP_IMG_URL + '/' + res.data.data.headerUrl
                        this.backImgUrl = process.env.VUE_APP_IMG_URL + '/' + res.data.data.backHeaderUrl
                        this.handImgUrl = process.env.VUE_APP_IMG_URL + '/' + res.data.data.handheldUrls
                    }
                }
            })
        },
        sureVerifiedHandler(){
            var data =  JSON.parse(JSON.stringify(this.verifiedInfo));
            data.backUrl = this.$refs.file1.files[0];
            data.frontUrl = this.$refs.file2.files[0];
            data.handUrl = this.$refs.file3.files[0];
            let formData = new FormData();
            formData.append('backUrl',this.$refs.file1.files[0]);
            formData.append('frontUrl',this.$refs.file2.files[0]);
            formData.append('handUrl',this.$refs.file3.files[0]);
            formData.append('handUrl1',this.$refs.file4.files[0]);
            formData.append('iccid',this.verifiedInfo.iccid);
            formData.append('remark',this.verifiedInfo.remark);
            formData.append('phone',this.verifiedInfo.phone);
            wxRequest("wxAuth/yue/sub", formData, "post").then((res) => {
                if(res.data.code == 200){
                    this.$messagebox.alert('提交成功！预计三个工作日内处理完成');
                }else{
                    this.$messagebox.alert(res.data.message);
                }
            })
            
        },
        showImg(event, showImgkey, imgUrl){
            this.$data[showImgkey] = true;
            const files = event.target.files
            let filename = files[0].name          //只有一个文件
            if ( filename.lastIndexOf('.') <= 0 ) {
                return alert("Please add a valid image!")        //判断图片是否有效
            }
            const fileReader = new FileReader()                //内置方法new FileReader()   读取文件
            fileReader.addEventListener('load',() => {
                this.$data[imgUrl] = fileReader.result
            })
            fileReader.readAsDataURL(files[0])
            this.image = files[0]
        }
    },
    created(){
    },

    mounted(){
    },

    quitHome() {
        this.$router.push({
          path:"/user/home",
      });
    }

}
</script>
<style lang="less">
#verified {
    height: 100%;
    h4 {
        color: #fff;
        font-size: 10px;
        background: #ff9c3c;
        line-height: 1.5em;
        padding: 6px 3%;
    }
    .main {
        // height: calc(100% - 48px);
        padding: 0 4%;
        form{
            height: 100%;
        }
        .line {
            border-bottom: 1px solid #e5e5e5;
        }
        .many {
            display: flex;
            justify-content: space-between;
            label {
                display: block;
                line-height: 36px;
            }
            .uploadOuter {
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 48%;
                height: 100px;
                border: 1px dashed #e5e5e5;
                box-sizing: border-box;
                input[type=file] {
                    position: absolute;
                    top: 0;
                    width: 0;
                    width: 100%;
                    height: 100%;
                    opacity: 0;
                }                
                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .title {
            line-height: 28px;
            margin-top: 10px;
        }
        .btnOuter {
            display: flex;
            align-items: center;
            flex-direction: column;
            height: calc(100% - 424px);
            .mint-button{
                width:50%;
                margin-top: 10px;
            }
        }
    }


    .card-dianxin{
        width: 100%;
        height: 100%;
        h1{
            font-size: 14px;
            background: #fff;
            line-height: 1.5em;
            padding: 6px 3%;
        }
        .dianxin-iframe{
            width: 100%;
            height: 100%;
        }
    }

    .card-yidong{
        width: 100%;
        height: 100%;
        h1{
            font-size: 16px;
            background: #fff;
            line-height: 1.5em;
            padding: 3px 3%;
        }
        .dianxin-iframe{
            width: 100%;
            height: 100%;
        }
    }

    .card-other{
        width: 100%;
        height: 100%;
    }
    
}
</style>
